<div class="buttons-panel">
  <button class="floated" (click)="addUser()" color="primary" mat-raised-button>
    <mat-icon>add</mat-icon> {{ "add-user" | translate }}
  </button>
</div>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>{{ "mail" | translate }}</th>
    <td mat-cell *matCellDef="let element">
      <b>{{ element.email }}</b>
    </td>
  </ng-container>

  <ng-container matColumnDef="firstname">
    <th mat-header-cell *matHeaderCellDef>{{ "name" | translate }}</th>
    <td mat-cell *matCellDef="let element">{{ element.firstname }}</td>
  </ng-container>

  <ng-container matColumnDef="lastname">
    <th mat-header-cell *matHeaderCellDef>{{ "surname" | translate }}</th>
    <td mat-cell *matCellDef="let element">{{ element.lastname }}</td>
  </ng-container>

  <ng-container matColumnDef="roles">
    <th mat-header-cell *matHeaderCellDef>{{ "user-type" | translate }}</th>
    <td mat-cell *matCellDef="let element">
      {{ getRoleString(element.roles) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let element">
      <div class="actions-panel">

        <button *ngIf="!element.emailConfirmed" class="confirm-btn" color="primary" mat-raised-button
          (click)="approveUser($event,element)">
          <mat-icon>check</mat-icon>
          {{ "approve" | translate }}
        </button>

        <mat-icon (click)="editUser($event, element)">edit</mat-icon>

        <mat-icon (click)="deleteUser(element)" matTooltip="Delete">delete</mat-icon>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr mat-row *matRowDef="let element; columns: columnsToDisplay"></tr>
</table>

<mat-paginator #paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions">
</mat-paginator>
